import * as React from 'react';

import { Pagination } from '@coursera/cds-core';

import { useSortablePaginatedTableContext } from './SortablePaginatedTableProvider';

const ConnectedPaginator = () => {
  const { pagination } = useSortablePaginatedTableContext();
  const { page, pageSize, setPage, setPageSize, totalRecords } = pagination;

  const isLoadingOrNoRows = totalRecords === 0;

  if (isLoadingOrNoRows) {
    return null;
  }

  return (
    <Pagination
      page={page}
      pageSize={pageSize}
      onPageChange={(_, newPage) => setPage(newPage)}
      onPageSizeChange={(_, newPageSize) => setPageSize(newPageSize)}
      total={totalRecords}
    />
  );
};

export default ConnectedPaginator;
